/**
 * A counter that tells a form whether an answer still belongs to it.
 *
 * Every asynchronous issue begins by taking the current generation; a company
 * switch, or anything else that resets the form, invalidates it. An answer
 * whose generation is no longer current was asked for by a form that no
 * longer exists — for another company, or for this one before the operator
 * left and came back (A → B → A) — and is dropped rather than applied.
 *
 * Pure: no Svelte and no browser API.
 */
export function createRequestGeneration() {
  let current = 0;
  return {
    begin: () => current,
    invalidate: () => { current += 1; },
    isCurrent: (generation) => generation === current,
  };
}
